import { render, staticRenderFns } from "./Home1920.vue?vue&type=template&id=0911214d&scoped=true"
import script from "./Home1920.vue?vue&type=script&lang=js"
export * from "./Home1920.vue?vue&type=script&lang=js"
import style0 from "./Home1920.vue?vue&type=style&index=0&id=0911214d&prod&lang=sass&scoped=true"
import style1 from "./Home1920.vue?vue&type=style&index=1&id=0911214d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0911214d",
  null
  
)

export default component.exports